import { createAsyncTypes } from 'utils/ActionCreator'

const ID = 'AgentsDashboard'

export const GET_DASHBOARD_ASYNC = createAsyncTypes('GET_DASHBOARD_ASYNC', ID)
export const GET_PERFORMANCE_ASYNC = createAsyncTypes('GET_PERFORMANCE_ASYNC', ID)
export const GET_DMARC_ASYNC = createAsyncTypes('GET_DMARC_ASYNC', ID)
export const GET_REDIRECTS_ASYNC = createAsyncTypes('GET_REDIRECTS_ASYNC', ID)
export const GET_ADOPTION_ASYNC = createAsyncTypes('GET_ADOPTION_ASYNC', ID)
export const GET_TRENDS_OVERVIEW_ASYNC = createAsyncTypes('GET_TRENDS_OVERVIEW_ASYNC', ID)
export const GET_BRIEFING_ASYNC = createAsyncTypes('GET_BRIEFING_ASYNC', ID)
export const GET_FEED_ASYNC = createAsyncTypes('GET_FEED_ASYNC', ID)

export const SET_DAYS_BACK = `${ID}/SET_DAYS_BACK`
export const SET_PAGE_VISIBLE = `${ID}/SET_PAGE_VISIBLE`
export const DASHBOARD_MOUNTED = `${ID}/DASHBOARD_MOUNTED`
export const DASHBOARD_UNMOUNTED = `${ID}/DASHBOARD_UNMOUNTED`
export const REFRESH_ALL = `${ID}/REFRESH_ALL`

export const setDaysBack = (daysBack) => ({ type: SET_DAYS_BACK, payload: daysBack })
export const setPageVisible = (visible) => ({ type: SET_PAGE_VISIBLE, payload: visible })
export const dashboardMounted = () => ({ type: DASHBOARD_MOUNTED })
export const dashboardUnmounted = () => ({ type: DASHBOARD_UNMOUNTED })
export const refreshAll = () => ({ type: REFRESH_ALL })
